import React, { useCallback } from "react";
import { LiaEditSolid } from "react-icons/lia";
import { MdTranslate } from "react-icons/md";

const Dilbilgisi = ({ 
  page, 
  setIsOpen, 
  setModalType,
  hesabimUserData,
  detayUserData
}) => {
  const userData = page === "hesabim" ? hesabimUserData : detayUserData;
  const languages = userData?.languages || [];

  // Edit ikonuna tıklandığında çalışacak fonksiyonu useCallback ile optimize ediyoruz
  const handleEditClick = useCallback(() => {
    setModalType("Dilbilgisi");
    setIsOpen(true);
  }, [setModalType, setIsOpen]);

  return (
    <div className="detay-container">
      <div
        className={`flex items-center text-dark text-lg tracking-wide font-medium ${
          page === "hesabim" ? "flex-row-reverse justify-between" : "flex gap-3"
        }`}
      >
        <span>
          {page === "hesabim" ? (
            <LiaEditSolid
              className="size-[24px] text-grayy cursor-pointer"
              onClick={handleEditClick}
            />
          ) : (
            <MdTranslate className="text-dark" />
          )}
        </span>
        <span>Dilbilgisi</span>
      </div>
      <div className="text-grayy text-sm pt-4">
        {!userData ? (
          <p>Yükleniyor...</p>
        ) : languages.length === 0 ? (
          <p>Henüz bir dil eklenmedi.</p>
        ) : (
          <ul className="list-disc ml-4">
            {languages.map((lang, index) => (
              <li key={index} className="my-2">
                {lang.language} ({lang.level})
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default React.memo(Dilbilgisi);
